import React from 'react';

import cx from 'classnames';
import styles from './styles.scss';

export default class Radio extends React.PureComponent {
  render() {
    const { size = 'full', invalid, value, options, ...rest } = this.props;

    const classes = cx(styles.radio, styles[size], {
      [styles.invalid]: invalid,
    });

    const labels = options.map(label => (
      <label key={label.value}>
        {label.label}{' '}
        <input type="radio" checked={value === label.value} name={this.props.name} value={label.value} {...rest} />
      </label>
    ));

    return <div className={classes}>{labels}</div>;
  }
}



// WEBPACK FOOTER //
// ./app/components/form/radio.js